<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460">
		<v-card>
			<v-card-title class="h6 justify-start" :class="(type === 'confirm') ? 'orange--text darken-2' : 'red--text darken-2'">{{ (type === 'confirm') ? 'Konfirmasi Registrasi' : 'Konfirmasi Registrasi' }}</v-card-title>
			<v-card-text class="text-left">
				<div class="d-block text-left" v-html="msg"></div>
			</v-card-text>
			<v-card-actions class="pb-5">
				<v-spacer></v-spacer>
				<template v-if="type === 'confirm'">
					<v-btn color="warning" depressed class="text-capitalize" :loading="btnLoading" @click.stop="confirm"><v-icon dense class="mr-1">mdi-account-box-multiple-outline</v-icon> {{ confirmText }}</v-btn>
					<v-btn color="grey darken-1" outlined class="text-capitalize" :loading="btnLoading" @click.stop="cancelled">{{ closeText }}</v-btn>
				</template>
				<template v-else>
					<v-btn color="grey darken-1" outlined class="text-capitalize" :loading="btnLoading" @click.stop="cancelled">Tutup</v-btn>
				</template>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			btnLoading: false,
			closeText: 'Ganti Nomor Identitas',
			confirmText: 'Kloning Akun Mitra'
		}
	},
	props: {
		msg: String,
		type: String
	},
	computed: {
	},
	methods: {
		modalHide() {
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
		loadingButton() {
			this.btnLoading = true
		},
		normalButton() {
			this.btnLoading = false
		},
		confirm() {
			this.$emit('action')
		},
		cancelled() {
			this.$parent.cancelConfirm()
			this.modalHide()
		}
	}
};
</script>